// import './message.scss';

export { default } from './Message';
export { default as template } from './message.tpl';
